import { toLocaleString2 } from '../strings'

export const parseReabMrpData = (data: any[]): any[] => {
  const res = []

  for (const item of data) {
    res.push({
      'centro-id': item.centroCodigo,
      'centro-nome': item.centroNome,

      'produto-id': item.produtoCodigo,
      'produto-material': item.produtoMaterial,
      'produto-status': item.produtoStatus,

      'fornecedor-id': item.fornecedorCodigo ? item.fornecedorCodigo : '-/-',
      'fornecedor-nome': item.fornecedorNome ? item.fornecedorNome : '',

      'estoque-atual': toLocaleString2(item.estoqueAtual),
      'estoque-cd': toLocaleString2(item.estoqueCd),
      'estoque-pedidos-transito': toLocaleString2(item.estoquePedidoEmTransito),
      'estoque-cobertura-atual': toLocaleString2(item.estoqueCoberturaAtual),
      'estoque-curva-abc': toLocaleString2(item.estoqueCurvaAbc),
      'estoque-quantidade-sugerida': toLocaleString2(
        item.estoqueQuantidadeSugerida
      ),
      'estoque-peso': toLocaleString2(item.estoquePeso),
      'calculo-saida-diaria':
        item.previsaoDemanda?.etapasCalculoSaidaMediaDiaria || [],
      'calculo-quantidade': item.etapasCalculoQuantidadeRecomendada || []
    })
  }

  return res
}
